<template>
  <div class="release-exhibitor">
    <RadioGroup v-model="status" type="button" style="margin-left:16px;">
      <Radio label="0">全部</Radio>
      <Radio label="1">洽谈中</Radio>
      <Radio label="2">已合作</Radio>
      <Radio label="3">未合作</Radio>
    </RadioGroup>
    <div style="padding: 0 20px;margin-top: 20px;">
      <Table :columns="columns1" :data="data1">
        <template slot-scope="{ row, index }" slot="comName">{{row.comName}}</template>
        <template slot-scope="{ row, index }" slot="link">{{row.link}}</template>
        <template slot-scope="{ row, index }" slot="tel">{{row.tel}}</template>
        <template slot-scope="{ row, index }" slot="type">{{row.type}}</template>
        <template slot-scope="{ row, index }" slot="info">
          <Tooltip :transfer="true" max-width="200" :content="row.info" placement="top">
            <p class="release-exhibitor-p">{{row.info}}</p>
          </Tooltip>
        </template>
        <template slot-scope="{ row, index }" slot="status">
          <p style="color:#1890ff;">{{row.status}}</p>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "release-exhibitor",
  data() {
    return {
      status: "0",
      columns1: [
        {
          title: "企业名称",
          key: "comName",
          slot: "comName",
          align: "center",
          width: 200
        },
        {
          title: "联系人",
          slot: "link",
          key: "link",
          align: "center"
        },
        {
          title: "联系方式",
          slot: "tel",
          key: "tel",
          align: "center"
        },
        {
          title: "供需类型",
          slot: "type",
          key: "type",
          align: "center"
        },
        {
          title: "供需内容",
          slot: "info",
          key: "info",
          align: "center",
          width: 300
        },
        {
          title: "当前状态",
          slot: "status",
          key: "status",
          align: "center"
        }
      ],
      data1: [
        {
          comName: '上海青年有限公司',
          link: '朱丽叶',
          tel: '13012346584',
          type: '供应产品',
          info: '寻找一家服装加工企业，要求日产量在200件以上寻找一家服装加工企业，要求日产量在200件以上寻找一家服装加工企业，要求日产量在200件以上寻找一家服装加工企业，要求日产量在200件以上',
          status: '洽谈中',
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
    }),
    option() {
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getRelease: "releaseModule/getRelease",
    }),
    async init() {
    },
  }
};
</script>

<style scoped lang="scss">
.release-exhibitor {
  min-width: 1000px;
  padding: 12px 0 30px 0;
  margin: 30px;
  background-color: #fff;
  .release-exhibitor-p {
    width: 300px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
}
</style> 
